"use client";

import React from "react";
import { ShieldCheck, Globe, Eye } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: ShieldCheck,
  title: "DSG Konformität",
  description: "Ihre Daten und Spenden werden nach strengsten Schweizer Datenschutzrichtlinien (nDSG) sicher und vertraulich verarbeitet.",
  badge: "Sicherer Standard"
}, {
  icon: Globe,
  title: "Swiss Hosted",
  description: "Unsere gesamte Infrastruktur wird ausschliesslich in hochsicheren Schweizer Rechenzentren betrieben und gewartet.",
  badge: "Lokale Präzision"
}, {
  icon: Eye,
  title: "Regulierte Umgebung",
  description: "Wir agieren in einem voll regulierten Umfeld, das Transparenz und Integrität für Stiftungen und Donoren garantiert.",
  badge: "Geprüfte Qualität"
}];
export default function QualityAssured() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222456" id="schweizer-qualitätsversprechen" className="relative w-full py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-5 rounded-lg blur-3xl" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24">
          <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-sm font-default bg-secondary/50 text-primary border-primary/10">
            Schweizer Qualitätsversprechen
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            Vertrauen durch Schweizer Präzision
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed max-w-2xl mx-auto">
            Crypto4Good vereint modernste Blockchain-Technologie mit den bewährten Werten des Schweizer Finanzplatzes für Ihre Philanthropie.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Card className="h-full bg-card border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-start text-left group rounded-2xl">
                <CardHeader className="flex flex-col items-start pt-8 pb-4 px-6">
                  <div className="h-20 w-20 ml-0 rounded-2xl bg-primary/5 flex items-center justify-center mb-6 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                    <feature.icon className="w-10 h-10 stroke-[1.5]" />
                  </div>
                  <Badge variant="outline" className="mb-4 bg-card border-primary/20 text-primary font-default">
                    {feature.badge}
                  </Badge>
                  <CardTitle className="text-2xl font-default text-foreground w-full">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 pb-6 px-6">
                  <p className="text-muted-foreground font-default leading-relaxed text-base">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}